export default __webpack_public_path__ + "static/media/1.6b5c0962.jpg";